<dx-box height="100%" width="100%" direction="col">
    <dxi-item [ratio]="1" class="cc-white-background">
        <div *dxTemplate>
            <div class="splitter-container" *ngIf="previousNotesVisible && allowNewNotes">
                <as-split direction="vertical" [useTransition]="true" unit="percent" gutterSize="3">
                    <as-split-area
                        class="as-split-area"
                        [size]="50"
                        [order]="previousNotesOrder"
                        [visible]="!!previousNotes"
                    >
                        <div class="textarea-container">
                            <span *ngIf="!hideTitle">Previous Notes</span>
                            <div class="textarea-content">
                                <dx-text-area
                                    class="textarea-input"
                                    [readOnly]="true"
                                    [value]="previousNotes"
                                ></dx-text-area>
                            </div>
                        </div>
                    </as-split-area>
                    <as-split-area class="as-split-area" [size]="50" [order]="newNotesOrder">
                        <div class="textarea-container">
                            <span *ngIf="!hideTitle">New Notes</span>
                            <div class="textarea-content">
                                <dx-text-area
                                    class="textarea-input"
                                    [readOnly]="false"
                                    [(value)]="newNotes"
                                ></dx-text-area>
                            </div>
                        </div>
                    </as-split-area>
                </as-split>
            </div>

            <div class="notes-container" *ngIf="!previousNotesVisible && allowNewNotes">
                <div class="textarea-container">
                    <span *ngIf="!hideTitle">New Notes</span>
                    <div class="textarea-content">
                        <dx-text-area
                            class="large-textarea-input"
                            [readOnly]="false"
                            [(value)]="newNotes"
                        ></dx-text-area>
                    </div>
                </div>
            </div>

            <div class="notes-container" *ngIf="!allowNewNotes">
                <div class="textarea-container">
                    <span *ngIf="!hideTitle">Previous Notes</span>
                    <div class="textarea-content">
                        <dx-text-area class="textarea-input" [readOnly]="true" [value]="previousNotes"></dx-text-area>
                    </div>
                </div>
            </div>
        </div>
    </dxi-item>
    <dxi-item baseSize="auto">
        <div *dxTemplate>
            <dx-toolbar width="100%">
                <dxi-item location="before" [visible]="!!previousNotes && allowNewNotes">
                    <div *dxTemplate>
                        <dx-button
                            [text]="showHidePreviousNotesButtonTitle"
                            type="default"
                            [visible]="!hidePreviousNotesButton"
                            (onClick)="onHidePreviousClick()"
                        ></dx-button>
                    </div>
                </dxi-item>
                <dxi-item location="before">
                    <div *dxTemplate>
                        <dx-button
                            text="Close"
                            type="default"
                            [icon]="iconClose"
                            (onClick)="onCloseClick()"
                        ></dx-button>
                    </div>
                </dxi-item>
                <dxi-item location="after" [disabled]="disableSave" [visible]="!allowUpdate && allowNewNotes">
                    <div *dxTemplate>
                        <dx-button
                            [text]="saveButtonTitle"
                            type="success"
                            [icon]="saveButtonIcon"
                            (onClick)="onSaveNotes()"
                        ></dx-button>
                    </div>
                </dxi-item>
                <dxi-item location="after" [disabled]="disableSave" [visible]="allowUpdate && allowNewNotes">
                    <div *dxTemplate>
                        <dx-button
                            text="Update"
                            type="success"
                            [icon]="saveButtonIcon"
                            (onClick)="onSaveNotes()"
                        ></dx-button>
                    </div>
                </dxi-item>
            </dx-toolbar>
        </div>
    </dxi-item>
</dx-box>
